import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import App from './app/App';
import AuthProvider from './app/providers/AuthProvider';
import FirebaseProvider from './app/providers/FirebaseProvider';
import ThemeProvider from './app/providers/ThemeProvider';
import { RegistrationSettingsProvider } from './features/bot-protection/context/RegistrationSettingsContext';
import { initializeSentry } from './lib/sentry';

// Initialize error monitoring and performance tracking
initializeSentry({
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  profilesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
});

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element with id "root" was not found in index.html');
}

ReactDOM.createRoot(container).render(
  <StrictMode>
    <FirebaseProvider>
      <AuthProvider>
        <RegistrationSettingsProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </RegistrationSettingsProvider>
      </AuthProvider>
    </FirebaseProvider>
  </StrictMode>,
);
